import * as React from 'react';

export const missingFontIconStyle: React.CSSProperties = {
    width: 16,
    height: 16,
    display: 'flex',
};
